function remove_variant_from_url(url, fieldId) {
  let urlArray = url.split("&");
  let newUrl = "";
  for (let element of urlArray) {
    let key = element.split("=")[0]
    if (key != "field:" + fieldId) {
      newUrl = newUrl == "" ? element : newUrl + "&" + element;
    }
  }
  return newUrl;
}

function add_variant_to_url (url, fieldId, sku) {
  let newUrl = url + "&field:" + fieldId + "=" + sku
  return newUrl;
}

var update_acuity_link_url = function(fieldId, sku) {
  let acuityButton = document.getElementById("acuity-embed-link");
  let appointmentUrl = acuityButton.href;
  appointmentUrl = remove_variant_from_url(appointmentUrl, fieldId);
  appointmentUrl = add_variant_to_url(appointmentUrl, fieldId, sku);
  acuityButton.href = appointmentUrl;
}
